const strings = {
  labels: {
    toasts: {
      callMissedInternalTitle: (missedCount: number) =>
        missedCount === 1
          ? 'You missed 1 internal call'
          : `You missed ${missedCount} internal calls`,
      callMissedExternalTitle: 'You missed 1 call due to caller hanging up.',
      rejectExternalCallTitle:
        'Your status has been changed to Unavailable due to rejecting an assigned call.',
      statusChangedTitle: 'Status Change',
      statusChangedBody: (missedCount: number) =>
        `You missed ${missedCount} call${missedCount > 1 ? 's' : ''}. Your status is now 'Unavailable'. Update your status if needed.`,
    },
  },
} as const;

export default strings;
